import useToken from 'hooks/useToken';
import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import SkeletonTable from '../../../components/common/SkeletonTable'

import { Badge, Button, Card, Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import { useToast } from 'context/providers/ToastProvider';

const Empleados = () => {

    const { token, setToken, idCatTipoUsuario } = useToken();
    const navigate = useNavigate();

    const [empleados, setEmpleados] = useState([]);
    const [cargando, setCargando] = useState(true);
    
    const { showErrorToast } = useToast();

    const columns = [
        {
            accessor: 'none',
            Header: '',
            Cell: rowData => {
                const { idUsuario } = rowData.row.original;
                return <>
                    <Link to={"/contabilidad/empleados/detalle/" + idUsuario} >
                        <img title="Ver informaci&oacute;n" src="/img/ver20.png"></img >
                    </Link>
                </>
            }
        },
        {
            accessor: 'idUsuario',
            Header: 'ID',
            headerProps: { className: 'pe-1' },
            Cell: rowData => {
                const { idUsuario } = rowData.row.original;
                return <>
                    <Link
                        to={"/contabilidad/empleados/detalle/" + idUsuario}
                    >
                        <span>{idUsuario}</span>
                    </Link>

                </>
            }
        },
        //{
        //    accessor: 'idCatTipoUsuario',
        //    Header: 'T',
        //    headerProps: { className: 'pe-1' },
        //    cellProps: {
        //        className: 'py-2'
        //    },
        //    Cell: rowData => {
        //        const { idCatTipoUsuario } = rowData.row.original;
        //        return (
        //            <span className="d-inline-block text-truncate">
        //                {idCatTipoUsuario}
        //            </span>
        //        );
        //    }
        //},
        {

            accessor: 'vNombre',
            Header: 'Nombre',
            Cell: rowData => {
                const { vNombre, vApellidos } = rowData.row.original;
                return <span>{vApellidos} {vNombre}</span>
            }
        },
        {
            accessor: 'iCategoria',
            Header: 'Categoria',
            headerProps: { className: 'pe-1' },
            Cell: rowData => {
                const { iCategoria, bIsActive } = rowData.row.original;
                return (
                    <>
                        {iCategoria == 1 ? <Badge bg="primary">Empleado</Badge> : iCategoria == 2 ? <Badge bg="danger">Hon. Prof.</Badge> : iCategoria == 3 ? <Badge bg="warning" text="dark">Residente</Badge> : iCategoria == 4 ? <Badge bg="success">Becario</Badge> : <Badge bg="light" text="dark"></Badge>}
                        &nbsp;{bIsActive == 1 ? <Badge bg="success">Activo</Badge> : <Badge bg="danger">Baja</Badge>}
                    </>
                );
            }
        },
        {
            accessor: 'vCURP',
            Header: 'C.U.R.P.',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { vCURP } = rowData.row.original;
                return <span className="d-inline-block text-truncate" style={{ maxWidth: '100px' }}> {vCURP} </span>
            }
        },
        {
            accessor: 'dFechaNacimiento',
            Header: 'Fecha Nac.',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { dFechaNacimiento } = rowData.row.original;
                return <span> {dFechaNacimiento}</span>;
            }
        },
        {
            accessor: 'vDatosContactoPersonal',
            Header: 'Tel. Personal',
            Cell: rowData => {
                const { vDatosContactoPersonal } = rowData.row.original;
                return <>
                    <span>{vDatosContactoPersonal}</span>
                </>
            }
        },
        {
            accessor: 'vTelefonoTrabajo',
            Header: 'Tel. Trabajo',
            Cell: rowData => {
                const { vTelefonoTrabajo } = rowData.row.original;
                return <>
                    <span>{vTelefonoTrabajo}</span>
                </>
            }
        },
        {
            accessor: 'vEmailTrabajo',
            Header: 'Email Trabajo',
            Cell: rowData => {
                const { vEmailTrabajo } = rowData.row.original;
                return <span>{vEmailTrabajo}</span>;
            }
        },
        {
            accessor: 'dFechaIngreso',
            Header: 'Fecha Ingreso',
            Cell: rowData => {
                const { dFechaIngreso } = rowData.row.original;
                return <span>{dFechaIngreso}</span>;
            }
        }
    ];

    // Agregar estos estados en tu componente
    const [filtroCategoria, setFiltroCategoria] = useState('todos');
    const [filtroEstatus, setFiltroEstatus] = useState('todos');

    // Función para filtrar empleados
    const empleadosFiltrados = useMemo(() => {
        let resultado = empleados;

        // Filtrar por categoría
        if (filtroCategoria !== 'todos') {
            resultado = resultado.filter(emp => emp.iCategoria == parseInt(filtroCategoria));
        }

        // Filtrar por estatus
        if (filtroEstatus !== 'todos') {
            if (filtroEstatus === 'activo') {
                resultado = resultado.filter(emp => emp.bIsActive === true);
            } else if (filtroEstatus === 'baja') {
                resultado = resultado.filter(emp => emp.bIsActive === false);
            }
        }

        return resultado;
    }, [empleados, filtroCategoria, filtroEstatus]);

    /**
     * Obtiene los empleados y los muestra en la tabla
     */
    const mostrarEmpleados = async () => {

        setCargando(true)

        const response = await fetch("/api/usuario/ObtenerEmpleados",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
                setCargando(false);

            });

        if (response.ok) {

            console.log("==== OBTENER LISTA EMPLEADOS ====");

            const data = await response.json();

            if (data.iResponseType == 1) {


                var ObjDetalles = JSON.parse(data.detalles);

                console.log(ObjDetalles)

                if (ObjDetalles.table2[0]) {

                    var empleados_ = ObjDetalles.table2

                    setEmpleados(empleados_);


                    console.log("TABLA EMPLEADOS", empleados_);

                }
            } else {
                showErrorToast(data.vMessage);
            }
            setCargando(false);

        }
        else {
            setCargando(true);
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };
    
    //Se muestra una vez
    useEffect(() => {
        

        if (idCatTipoUsuario != 1) {
            navigate("/");
        }

        checkPermisos();
    }, []);

    /**
     * Verifica los permisos
     */
    const checkPermisos = async () => {

        const response = await fetch("/api/Administradores/checkPermisos",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);

                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {
                //
                mostrarEmpleados();
            } else {
                navigate("/");
            }

        }
        else {
            navigate("/");
        }
    }

    return (
        <>
            <Card className="mb-1 p-2">
                <Row className="g-2 align-items-sm-center">
                    <Col xs="auto">
                        <img src="/img/vendedor35.png" alt="connectCircle" height={30} />
                    </Col>
                    <Col>
                        <h5>
                            Empleados / Usuarios del sistema
                        </h5>
                    </Col>
                    <Col sm="auto" className="ms-auto">
                        <Link to="/contabilidad/empleados/nuevo">
                            <Button size="sm"
                                variant="falcon-primary"
                            >
                                Nuevo Usuario
                            </Button>
                        </Link>
                    </Col>
                </Row>
            </Card>

            <AdvanceTableWrapper
                columns={columns}
                data={empleadosFiltrados} // Usar array filtrado en lugar de empleados
                sortable
                pagination
                perPage={15}
            >
                <Card className="mb-3">
                    <Card.Header>
                        <Row className="gx-3 gy-2 align-items-end">
                            {/* Filtro Categoría */}
                            <Col xs={12} sm={6} md={3} lg={2}>
                                <Form.Group>
                                    <Form.Label className="mb-1 fs--2 text-600">Categor&iacute;as:</Form.Label>
                                    <Form.Select
                                        size="sm"
                                        value={filtroCategoria}
                                        onChange={(e) => setFiltroCategoria(e.target.value)}
                                    >
                                        <option value="todos">Todas las categor&iacute;as</option>
                                        <option value="1">Empleado</option>
                                        <option value="2">Hon. Prof.</option>
                                        <option value="3">Residente</option>
                                        <option value="4">Residente becado</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            {/* Filtro Estatus */}
                            <Col xs={12} sm={6} md={3} lg={2}>
                                <Form.Group>
                                    <Form.Label className="mb-1 fs--2 text-600">Estatus:</Form.Label>
                                    <Form.Select
                                        size="sm"
                                        value={filtroEstatus}
                                        onChange={(e) => setFiltroEstatus(e.target.value)}
                                    >
                                        <option value="todos">Todos</option>
                                        <option value="activo">Activo</option>
                                        <option value="baja">Baja</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            {/* Search Box */}
                            <Col xs={12} sm={12} md={6} lg={8} className="ms-md-auto">
                                <div className="d-flex justify-content-end">
                                    {!cargando &&
                                        <div style={{ minWidth: '250px' }}>
                                            <AdvanceTableSearchBox table />
                                        </div>
                                    }
                                </div>
                            </Col>
                        </Row>
                    </Card.Header>

                    <Card.Body className="p-0">
                        {cargando ? (
                            <SkeletonTable columnNames={['ID', 'Nombre', 'Categoria', 'C.U.R.P.', 'Fecha Nac.', 'Tel. Personal', 'Tel. Trabajo', 'Email Trabajo', 'Fecha Ingreso']} rows={8} />
                        ) : (
                            <AdvanceTable
                                table
                                headerClassName="bg-200 text-900 text-nowrap align-middle"
                                rowClassName="align-middle white-space-nowrap"
                                tableProps={{
                                    size: 'sm',
                                    striped: true,
                                    className: 'fs--2 mb-0 overflow-hidden'
                                }}
                            />
                        )}
                    </Card.Body>

                    <Card.Footer>
                        <AdvanceTableFooter
                            rowCount={empleadosFiltrados.length} 
                            table
                            rowInfo
                            navButtons
                            rowsPerPageSelection
                        />
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>


          
        </>
    );
};

export default Empleados;
